import React from 'react';

import './SearchResult.scss';

class SearchResult extends React.Component {
    constructor(props) {
        super(props);
        // this.handleSubmit = this.handleSubmit.bind(this);
    }

    render() {
        const {searchResult} = this.props;

        function parsePublicationDate() {
            var monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            var parsedDate = searchResult.publicationDate.match(/([^-]+)/g);
            if (parsedDate[1]) {
                return `${monthNames[parseInt(parsedDate[1])]}, ${parsedDate[0]}`;
            }
            return parsedDate[0];
        }

        return (
            <div className="search-result-container">
                <div className="image-container">
                    <img src={searchResult.imageLinks.large}/>
                </div>
                <div className="book-info">
                    <div className="title">
                        <a href={searchResult.productLink}
                           target="_blank">{searchResult.title.concat(', ', searchResult.edition)}</a>
                    </div>
                    <div className="author">{searchResult.author}</div>
                    <div className="publication-year">{parsePublicationDate()}</div>
                    <div className="publisher">{searchResult.publisher}</div>
                    <div className="binding">{searchResult.binding}</div>
                    <div className="isbn">ISBN: {searchResult.ISBN}</div>
                    <div className="price">{searchResult.price.FormattedPrice}</div>
                    <div className="prime">Prime Eligible: {searchResult.primeEligible ? 'Yes' : 'No'}</div>
                    <div className="other-offers">
                        <a href={searchResult.viewMoreOffersLink} target="_blank">View More Offers</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchResult;



/** WEBPACK FOOTER **
 ** ./src/components/SearchResult/SearchResult.js
 **/